/* The rail's head — the tag boards' `F1-szczegoly`: `.aka`, the `.bt` with its `.cnt`, the `.tag`
 * chips, the `.field` and the `.note`. 10 October 2026.
 *
 * Every text leaf states its line-height. The counts and the note are `--text-2` rather than the
 * board's `--text-3`, which measures 3.01:1 in Flame — deviations register entry 18's call, made
 * for every small figure on this screen. */

.aliases {
  flex: none;
  margin: var(--space-0);
  font-size: var(--fs-note);
  font-weight: var(--fw-semibold);
  line-height: var(--lh-note);
  color: var(--text-2);
}

.alias {
  font-weight: var(--fw-bold);
  color: var(--text);
}

/* The rail's own heading, with the glyph before it and the count pushed to the end of the line. */
.title {
  display: flex;
  gap: var(--space-2);
  align-items: center;
}

.glyph {
  flex: none;
  width: 15px;
  height: 15px;
  color: var(--text-2);
}

.count {
  margin-left: auto;
  font-size: var(--fs-label);
  font-weight: var(--fw-bold);
  line-height: var(--lh-auto);
  letter-spacing: normal;
  color: var(--text-2);
  font-variant-numeric: tabular-nums;
}

.chips {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-6px);
  margin: var(--space-0) var(--space-0) var(--space-10px);
  padding: var(--space-0);
  list-style: none;
}

/* The field's own width, so the list reads as the field's rather than as a menu beside it. */
.popup {
  width: var(--anchor-width);
}

/* „Dodaj nowy tag „…”" is set apart from the trainer's tags by a rule — when there are any. */
.create:not(:first-child) {
  margin-top: var(--space-1);
  border-top: var(--border-hairline) solid var(--border);
}

.uses {
  flex: none;
  font-size: var(--fs-eyebrow);
  font-weight: var(--fw-bold);
  line-height: var(--lh-auto);
  color: var(--text-2);
  font-variant-numeric: tabular-nums;
}

.notice {
  margin: var(--space-2) var(--space-0) var(--space-0);
  font-size: var(--fs-label);
  font-weight: var(--fw-semibold);
  line-height: var(--lh-note);
  color: var(--text);
}

/* Empty, it stays in the tree — a status region inserted with its text is not announced — and
 * takes no room. */
.notice:empty {
  margin: var(--space-0);
}

.note {
  margin: var(--space-2) var(--space-0) var(--space-0);
  font-size: var(--fs-label);
  font-weight: var(--fw-medium);
  line-height: var(--lh-note);
  color: var(--text-2);
}
